"use strict";
import { baseUrl } from "../config/env";
import *  as signalr from "@aspnet/signalr";
import { getStore, clearUserInStore, getBrowserBrandName } from "../config/mUtils";

export class hubHandler {
  connection;

  constructor() {

    const me = this;

    //判断如果是 Safari 浏览器, 只要页面切回来就要调一次 resume.
    if(getBrowserBrandName().toLowerCase().indexOf("safari") > -1)
    {
      document.addEventListener("visibilitychange", function() {

        //如果用户切回来了
        if (document.visibilityState === 'visible')
            me.resume();

      });
    }
    
  }

  //建立连接
  async buildConnection(beforeLogout, retryCount) {
    
    if (retryCount > 3) {
      return;
    }

    try {

      this.connection = new signalr.HubConnectionBuilder()
        .configureLogging(signalr.LogLevel.None)
        .withUrl(baseUrl + "/videoHub", {
          accessTokenFactory: () => getStore("auth_token"),
          withCredentials: false
        }).build();
      this.connection.serverTimeoutInMilliseconds = 30000;//30s

      const me = this;
      //连接被关闭
      this.connection.onclose(function (error) {
        if (error) {
          console.error("WS connection disconnected. Reason: " + error.message + ", Reconnecting...");
        }
     
        me.retryHandler = setInterval(function () {
          let token = getStore("auth_token");
          if (!token){
            clearInterval(me.retryHandler);
            return;
          }
          //如果还是在连接期间就不要重复连接了.
          if (me.connection.connection.connectionState !== 2)
            return;
          //console.log("retryHandler", me.connection);
          me.connection.start().then(() => {
            clearInterval(me.retryHandler);

            //连接成功, 调用 resume 告诉服务器我回来了.
            me.resume.call(me);
            console.log("reconnected.");
          }).catch((ex) => {
            console.error("error on reconnecting: " + ex.message);
            console.log(ex);
          });

        }, 5000);

      });

      //登录冲突
      this.connection.on("conflicting-logins-detected", (receipt) => {
        this.sendMsg("message-recived", receipt);
        this.onUserLogout(beforeLogout, '您已在其他设备/浏览器上登录, 当前页面自动登出');
      });

      this.connection.on("rebind-device", (receipt) => {
        this.sendMsg("message-recived", receipt);
        this.onUserLogout(beforeLogout, '当前设备已经移除，需重新绑定, 当前页面自动登出');
      });

      //连接建立后自动调用注册设备
      //console.log("register", this.connection);
      this.connection.start().then(() => {
        this.register();
      });

    } catch (e) {

      console.log(e);
      await new Promise((resolve) => setTimeout(() => {
        if (typeof retryCount == undefined) {
          retryCount = 0;
        }
        retryCount++;
        this.buildConnection(beforeLogout, retryCount)
        resolve();
      }, 1000));
    }
  }

  //恢复设备注册
  resume () {
    this.sendMsg("resume", getStore("user_deviceid"));
  }

  //注册设备
  register() {
    this.sendMsg("register", getStore("user_deviceid"));
  }

  //设备反注册
  unregister() {
    let deviceid = getStore("user_deviceid");
    this.sendMsg("unregister", deviceid);
  }

  checkConnectionStatus() {
    // console.log("checkConnectionStatus-connection", this.connection);
    // if (this.connection){
    //   console.log("checkConnectionStatus-connectionState", this.connection.connection.connectionState);
    // }
    try {
      if (this.connection && this.connection.connection.connectionState == 2) {
        console.log("checkConnectionStatus", this.connection);
        this.connection.start().then(() => {
          this.resume();
        });

      }
    } catch (e) {
      console.log(e);
    }
  }

  sendMsg(method, msg){
    try {
      if (this.connection && this.connection.connection.connectionState == 1) {
        this.connection.send(method, msg);  
      }
    } catch (e) {
      console.log(e);
    }
  }

  removeEvents(){
    if (this.connection){
      this.connection.off("onclose");
      this.connection.off("rebind-device");
      this.connection.off("conflicting-logins-detected");
    }
  }

  //初始化
  async initialize(beforeLogout) {
    try {
      if (!this.connection || this.connection.connection.connectionState == 0) {
        this.removeEvents();
        await this.buildConnection(beforeLogout);
      }
    } catch (e) {
      console.log(e);
    }
  }

  //检测到登录冲突
  onUserLogout(beforeLogout, msg) {
    this.unregister();
    clearUserInStore();

    const logout = () => {
      location.href = "/";
    };

    if (beforeLogout) {
      if (beforeLogout(msg)) {
        logout();
      }
    }
    else {
      logout();
    }

  };

};



// WEBPACK FOOTER //
// ./src/script/hubHandler.js